const SkipLink = () => {
  // Detect language from URL directly so this component can render
  // outside of TranslationProvider (it sits at the very top of the tree).
  const isEnglish =
    typeof window !== 'undefined' && /^\/en(\/|$)/.test(window.location.pathname);
  const label = isEnglish ? 'Skip to main content' : 'Zum Inhalt springen';

  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-waldgruen focus:text-softwhite focus:rounded-md focus:font-semibold focus:no-underline focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-waldgruen focus:ring-offset-2"
    >
      {label}
    </a>
  );
};

export default SkipLink;